<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
    :style="{
      color: options.color.kjkSecondary
    }"
  >
    <table cellspacing="0" width="500" cellpadding="0" border="0">
      <tbody>
        <tr>
          <td width="90" style="vertical-align: top;padding-top: 5px;padding-right: 40px;" valign="top">
            <table cellspacing="0" cellpadding="0" border="0" width="90">
              <tbody>
                <tr>
                  <td width="90">
                    <img alt="kjk logo" width="90" style="width:90px;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;" src="https://kjk-law.com/wp-content/uploads/2021/01/kjk-logo.png" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td width="370" style="vertical-align: top;" valign="top">
            <table cellspacing="0" cellpadding="0" border="0" width="370">
              <tbody>
                <tr>
                  <td :style="{ color: options.color.kjkPrimary }">
                    <div>
                      <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 18px; font-weight: bold;">{{
                        mainFields[0].value || ''
                      }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;" :style="{ color: options.color.kjkPrimary }">
                    <div>
                      <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;">{{ mainFields[1].value || '' }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 10px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px; font-weight: bold;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px; font-weight: bold;"
                      >KJK Kolmann Jakobs Kramer Rechtsanwälte PartGmbB</span
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                      >Marienstraße 14-16 | D-80331 München</span
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 10px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;vertical-align: top;"
                    valign="top"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <table cellspacing="0" cellpadding="0" border="0" width="370">
                      <tbody>
                        <tr>
                          <td width="11"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;padding-right: 6px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <img alt="email icon" width="11" style="width:11px;vertical-align: middle;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;" src="https://kjk-law.com/wp-content/uploads/2021/01/icon-mail.png" />
                          </td>
                          <td
                            width="483"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;">{{ otherFields[0].value || '' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    v-if="otherFields[1].value"
                    style="padding-top: 4px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;vertical-align: top;"
                    valign="top"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <table cellspacing="0" cellpadding="0" border="0" width="370">
                      <tbody>
                        <tr>
                          <td width="11"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;padding-right: 6px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <img alt="email icon" width="11" style="width:11px;vertical-align: middle;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;" src="https://kjk-law.com/wp-content/uploads/2021/01/icon-mobile.png" />
                          </td>
                          <td
                            width="483"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;">{{ otherFields[1].value || '' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 4px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;vertical-align: top;"
                    valign="top"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <table cellspacing="0" cellpadding="0" border="0" width="370">
                      <tbody>
                        <tr>
                          <td width="11"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;padding-right: 6px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <img alt="email icon" width="11" style="width:11px;vertical-align: middle;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;" src="https://kjk-law.com/wp-content/uploads/2021/01/icon-phone.png" />
                          </td>
                          <td
                            width="483"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;">{{ otherFields[2].value || '' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 4px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;vertical-align: top;"
                    valign="top"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <table cellspacing="0" cellpadding="0" border="0" width="370">
                      <tbody>
                        <tr>
                          <td width="11"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;padding-right: 6px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <img alt="email icon" width="11" style="width:11px;vertical-align: middle;moz-border-radius:0%;khtml-border-radius:0%;o-border-radius:0%;webkit-border-radius:0%;ms-border-radius:0%;border-radius:0%;" src="https://kjk-law.com/wp-content/uploads/2021/01/icon-fax.png" />
                          </td>
                          <td
                            width="483"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <span style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;">{{ otherFields[3].value || '' }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 4px;font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;vertical-align: top;"
                    valign="top"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <table cellspacing="0" cellpadding="0" border="0" width="370">
                      <tbody>
                        <tr>
                          <td
                            width="370"
                            style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px;"
                            :style="{ color: options.color.kjkSecondary }"
                          >
                            <a
                              style="font-family: Rubik, Arial, sans-serif; font-size: 12px; line-height: 16px; text-decoration:none !important; text-decoration:none;"
                              :style="{ color: options.color.kjkSecondary }"
                              href="https://kjk-law.com?ref=email-signature"
                              >www.kjk-law.com</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 10px;font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; font-weight: bold;"
                      >Gesellschaftsform / Company type:</span
                    >&nbsp;
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                      >PartGmbB (partnership of lawyers with limited professional liability)</span
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 0px;font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; font-weight: bold;"
                      >Sitz / Registered Seat:</span
                    >&nbsp;
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                      >München | Amtsgericht München (PR 2129)</span
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 0px;font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; font-weight: bold;"
                      >Partner / Partners:</span
                    >&nbsp;
                    <a
                      style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; text-decoration:none !important; text-decoration:none;"
                      :style="{ color: options.color.kjkSecondary }"
                      href="https://kjk-law.com/impressum"
                      >www.kjk-law.com/impressum</a
                    >
                  </td>
                </tr>
                <tr>
                  <td
                    style="padding-top: 0px;font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px;"
                    :style="{ color: options.color.kjkSecondary }"
                  >
                    <span style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; font-weight: bold;"
                      >Datenschutzhinweise / Privacy Policy:</span
                    >&nbsp;
                    <a
                      style="font-family: Rubik, Arial, sans-serif; font-size: 10px; line-height: 14px; text-decoration:none !important; text-decoration:none;"
                      :style="{ color: options.color.kjkSecondary }"
                      href="https://kjk-law.com/datenschutz"
                      >www.kjk-law.com/datenschutz</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style="line-height: 1px;" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from './emailTemplate';

export default {
  name: 'KJKAllgemein',

  components: {},

  extends: EmailTemplate,

  data() {
    return {
      filterFields: ['fullName', 'jobTitle']
    };
  },

  computed: {
    otherFields() {
      if (this.isEmpty) {
        /* eslint-disable no-undef */
        return fields.basicPlaceholder.filter(item => !this.filterFields.includes(item.key));
      }
      let arr = this.basic.fields.filter(
        item => !this.filterFields.includes(item.key) // && item.value
      );

      return arr;
    },
    isCustomFieldsExist() {
      return this.otherFields.some(i => i.custom);
    }
  }
};
</script>
